module.exports = __webpack_public_path__ + "static/img/shipin23.294c144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shipin23.png
// module id = N0QA
// module chunks = 10